// Local translations
export const T = {
  en_GB: {
    addColor: "Add colour",
    color: "Colour",
    settings: "Settings",
    theme: "Theme",
    description: "Customize your organization's logo and brand colors.",
    // Brand color
    brandColor: "Brand Color",
    brandColorDescription: "Your brand color is used for charts and visual accents.",
    // Chart colors
    chartColors: "Chart Colors",
    chartColorsDescription:
      "Custom color palette for pie charts (asset allocation, x-ray charts). Colors are used in order and cycle if needed.",
    colorPalette: "Color Palette",
    generateFromBrand: "Generate from brand",
    resetToDefault: "Reset to default",
    reset: "Reset",
    customColorsCount: "custom colors",
    defaultPaletteCount: "Using default palette",
    // Logo
    logo: "Logo",
    logoDescription:
      "Upload your organization's logo in SVG format. You can provide separate logos for light and dark mode.",
    logoLightMode: "Logo (Light Mode)",
    logoLightModeDescription:
      "This logo appears when the app is in light mode. Use a dark-colored logo.",
    logoDarkMode: "Logo (Dark Mode)",
    logoDarkModeDescription:
      "This logo appears when the app is in dark mode. Use a light-colored logo.",
    remove: "Remove",
    uploading: "Uploading...",
    // Actions
    save: "Save",
    // Messages
    invalidFileType: "Invalid file type",
    invalidFileTypeDescription: "Please upload an SVG file for the logo",
    fileTooLarge: "File too large",
    fileTooLargeDescription: "Logo size must be less than 1MB",
    uploadFailed: "Upload failed",
    uploadFailedDescription: "Failed to upload logo. Please try again.",
    error: "Error",
    failedToSaveTheme: "Failed to save theme",
    themeSettingsSaved: "Saved",
  },
  nb_NO: {
    addColor: "Legg til farge",
    color: "Farge",
    settings: "Innstillinger",
    theme: "Tema",
    description: "Tilpass organisasjonens logo og merkefarger.",
    // Brand color
    brandColor: "Merkefarge",
    brandColorDescription: "Din merkefarge brukes til diagrammer og visuelle aksenter.",
    // Chart colors
    chartColors: "Diagramfarger",
    chartColorsDescription:
      "Tilpasset fargepalett for sektordiagrammer (aktivaallokering, x-ray-diagrammer). Fargene brukes i rekkefølge og gjentas ved behov.",
    colorPalette: "Fargepalett",
    generateFromBrand: "Generer fra merkefarge",
    resetToDefault: "Tilbakestill til standard",
    reset: "Tilbakestill",
    customColorsCount: "egendefinerte farger",
    defaultPaletteCount: "Bruker standardpalett",
    // Logo
    logo: "Logo",
    logoDescription:
      "Last opp organisasjonens logo i SVG-format. Du kan oppgi separate logoer for lys og mørk modus.",
    logoLightMode: "Logo (Lys modus)",
    logoLightModeDescription: "Denne logoen vises når appen er i lys modus. Bruk en mørk logo.",
    logoDarkMode: "Logo (Mørk modus)",
    logoDarkModeDescription: "Denne logoen vises når appen er i mørk modus. Bruk en lys logo.",
    remove: "Fjern",
    uploading: "Laster opp...",
    // Actions
    save: "Lagre",
    // Messages
    invalidFileType: "Ugyldig filtype",
    invalidFileTypeDescription: "Vennligst last opp en SVG-fil for logoen",
    fileTooLarge: "Filen er for stor",
    fileTooLargeDescription: "Logostørrelsen må være under 1MB",
    uploadFailed: "Opplasting mislyktes",
    uploadFailedDescription: "Kunne ikke laste opp logo. Vennligst prøv igjen.",
    error: "Feil",
    failedToSaveTheme: "Kunne ikke lagre tema",
    themeSettingsSaved: "Lagret",
  },
} as const;
